import common from './common';

function shareLeagueOnFacebook(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans, type) {
    e.stopPropagation();
    // common.customTracking('Share - Facebook');
    common.virPathTracking('leagueInviewShare');
    /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + ShareLoad;*/
    let description, caption = "";
    const { fb_league_share_caption, fb_league_share_description, fb_team_share_caption, fb_team_share_description } = trans;
    if (type == 'team') {
        description = fb_team_share_description ? fb_team_share_description : "";
        caption = fb_team_share_caption ? fb_team_share_caption : "Caption";
    } else {
        description = ""//fb_league_share_description;
        caption = ""//fb_league_share_caption
    }
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(ShareLoad) + "&quote=" + description, caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
    /*window.FB.ui({
        method : 'feed',
        link   : URL,
        display: 'popup',
        caption: fb_league_share_caption,
        quote  : fb_league_share_description
    }, function (response) {
    });*/
}

function shareLeagueOnTwitter(e, LeagueCode, LeagueId, LeagueName, ShareLoad, trans, type) {
    e.stopPropagation();
    // common.customTracking('Share - Twitter');
    common.virPathTracking('leagueInviewShare');
    let description, caption = "";
    const { fb_league_share_caption, fb_league_share_description, fb_team_share_caption, fb_team_share_description } = trans;
    if (type == 'team') {
        description = fb_team_share_description ? fb_team_share_description : "";
        caption = fb_team_share_caption ? fb_team_share_caption : "Caption";
    } else {
        description = ""//fb_league_share_description;
        caption = ""//fb_league_share_caption
    }
    /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + ShareLoad;*/
    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(ShareLoad) + '&text=' + encodeURIComponent(description);
    window.open(url, caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
}

function shareDreamTeamOnFacebook(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    common.customTracking('Share Dream Team');
    /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + DreamTeamUrl;*/
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
    window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(DreamTeamUrl) + "&quote=" + fb_dreamteam_share_description, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
    /*window.FB.ui({
        method : 'feed',
        link   : URL,
        display: 'popup',
        caption: fb_dreamteam_share_caption,
        quote  : fb_dreamteam_share_description
    }, function (response) {
    });*/
}

function shareTeamOfTheSeasonOnFacebook(e, DreamTeamUrl, trans) {
  e.stopPropagation();
  // common.customTracking('Share Dream Team');
  /*const URL = config.BASE_URL + '/' + config.APP_NAME + '/leagues/' + DreamTeamUrl;*/
  const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;
  window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(DreamTeamUrl) + "&quote=" + fb_dreamteam_share_description, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
  /*window.FB.ui({
      method : 'feed',
      link   : URL,
      display: 'popup',
      caption: fb_dreamteam_share_caption,
      quote  : fb_dreamteam_share_description
  }, function (response) {
  });*/
}

function shareDreamTeamOnTwitter(e, DreamTeamUrl, trans) {
    e.stopPropagation();
    common.customTracking('Share Dream Team');
    const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;

    const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(DreamTeamUrl) + '&text=' + encodeURIComponent(fb_dreamteam_share_description);
    window.open(url, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
}

function shareTeamOfTheSeasonOnTwitter(e, DreamTeamUrl, trans) {
  e.stopPropagation();
  // common.customTracking('Share Dream Team');
  const { fb_dreamteam_share_caption, fb_dreamteam_share_description } = trans;

  const url = 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(DreamTeamUrl) + '&text=' + encodeURIComponent(fb_dreamteam_share_description);
  window.open(url, fb_dreamteam_share_caption, 'width=600,height=400, scrollbars=no, resizable=no, top=250, left=250', false);
}

export { shareLeagueOnFacebook, shareLeagueOnTwitter, shareDreamTeamOnFacebook, shareDreamTeamOnTwitter, shareTeamOfTheSeasonOnFacebook, shareTeamOfTheSeasonOnTwitter };


// WEBPACK FOOTER //
// ./src/share.js